var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchTrigger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-5.24537e-07 12C-2.34861e-07 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 -8.14212e-07 12 -5.24537e-07C5.373 -2.34861e-07 -8.14212e-07 5.373 -5.24537e-07 12ZM2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12ZM7 13C7 13.256 7.09797 13.512 7.29297 13.707L11.293 17.707C11.684 18.098 12.316 18.098 12.707 17.707L16.707 13.707C17.098 13.316 17.098 12.684 16.707 12.293C16.316 11.902 15.684 11.902 15.293 12.293L13 14.5859L13 7C13 6.448 12.553 6 12 6C11.447 6 11 6.448 11 7L11 14.5859L8.70703 12.293C8.31603 11.902 7.68397 11.902 7.29297 12.293C7.09797 12.488 7 12.744 7 13Z",
    fill: "#89939E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchTrigger);
export default __webpack_public_path__ + "static/media/search-trigger.34ceb4839998463bb285bd5cc21278b2.svg";
export { ForwardRef as ReactComponent };